export default {"src":"https://appsumo2next-cdn.appsumo.com/_next/static/media/streak.81a7001a.svg","height":10,"width":276};